<template>
  <div>
    <Aguarde :show="showAguarde"></Aguarde>
    <Loader :loading="httpSend">
      <div class="row">
        <div class="col-12">
          <b-form>
            <div class="row">
              <div class="col-md-4">
                <b-form-group label="CPF" label-for="tus_cpfcnpj">
                  <the-mask class="form-control"
                            id="tus_cpfcnpj"
                            :class="{ 'is-invalid': $v.usuario.tus_cpfcnpj.$error || cpfInvalido }"
                            v-model="usuario.tus_cpfcnpj"
                            :mask="['###.###.###-##']"/>
                  <div v-if="$v.usuario.tus_cpfcnpj.$error || cpfInvalido" class="invalid-feedback">
                    Informe um CPF válido
                  </div>
                </b-form-group>
              </div>
              <div class="col-md-8">
                <b-form-group label="E-mail" label-for="tus_mail">
                  <input class="form-control"
                         v-model="usuario.tus_mail"
                         maxlength="80"
                         :class="{ 'is-invalid': $v.usuario.tus_mail.$error }"
                         id="tus_mail" type="email">
                  <div v-if="$v.usuario.tus_mail.$error" class="invalid-feedback">
                    Informe um e-mail válido
                  </div>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <b-form-group class="mt-2 text-right">
                  <button type="button" @click="saveUsuario()"
                          title="Reenviar e-mail de confirmação"
                          class="btn btn-success mr-2 mb-2">
                    <i class="bx bx-check-double"></i> Salvar
                  </button>
                  <button type="button" @click="confirmacaoDelete()" title="Excluir Usuário"
                          class="btn btn-outline-danger mr-2 mb-2">
                    <i class="bx bxs-user-minus"></i> Excluir
                  </button>
                  <button type="button" @click="voltar()" title="Editar Usuário"
                          class="btn btn-outline-dark mr-2 mb-2">
                    <i class="bx bx-arrow-back"></i> Voltar
                  </button>
                </b-form-group>
              </div>
            </div>
          </b-form>
        </div>
      </div>
    </Loader>
  </div>
</template>
<script>
import {TheMask} from 'vue-the-mask'
import {required, email} from "vuelidate/lib/validators";
import Loader from "@/components/widgets/loader";
import Aguarde from "@/components/widgets/aguarde";
import {deleteUsuarioTemp, getUsuarioTemp, saveUsuarioTemp} from "@/api/admin/pessoas/pessoas";
import {validaCpfCnpj} from "@/helps/util";
import Swal from "sweetalert2";

export default {
  components: {
    Loader,
    Aguarde,
    TheMask
  },
  watch: {
    'usuario.tus_cpfcnpj': {
      handler(val) {
        this.cpfInvalido = !validaCpfCnpj(val);
      },
    },
  },
  data() {
    return {
      showAguarde: false,
      httpSend: false,
      cpfInvalido: false,
      usuario: {
        tus_codigo: null,
        tus_cpfcnpj: '',
        tus_mail: null,
      }
    };
  },
  validations: {
    usuario: {
      tus_cpfcnpj: {
        required,
      },
      tus_mail: {
        required,
        email
      },
    },
  },
  created() {
    if (this.$route.params.hash) {
      this.getUsuario();
    }
  },
  methods: {
    getUsuario() {
      this.httpSend = true;
      getUsuarioTemp(this.$route.params.hash).then(result => {
        if (result.status) {
          this.usuario = result.dados;
        } else {
          this.$toast.error(result.mensagem)
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    saveUsuario() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }
      if (validaCpfCnpj(this.usuario.tus_cpfcnpj) === false) {
        return false;
      }
      this.showAguarde = true;
      saveUsuarioTemp(this.usuario).then(result => {
        if (result.status) {
          this.$toast.success(result.mensagem)
        } else {
          this.$toast.error(result.mensagem)
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.showAguarde = false;
      })
    },
    confirmacaoDelete() {
      Swal.fire({
        title: "Deseja excluir o usuário?",
        text: "",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#100e0e",
        confirmButtonText: "Sim",
        cancelButtonText: "Não"
      }).then(result => {
        if (result.isConfirmed) {
          this.deleteUsuario();
        } else {
          return false;
        }
      });
    },
    deleteUsuario() {
      this.showAguarde = true;
      deleteUsuarioTemp(this.usuario.tus_codigo).then(result => {
        if (result.status) {
          this.$toast.error(result.mensagem)
          this.voltar();
        } else {
          this.$toast.error(result.mensagem)
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.showAguarde = false;
      })
    },
    voltar() {
      this.$router.push({name: "admin-pessoas-usuarios"})
    }
  }
};
</script>

